import React, {FC} from "react";
import {TaskSection} from "view/components/TaskDrawer";
import RichText from "view/components/RichText";
import {useTranslate} from "@tolgee/react";

/** Renders the latest organiser reaction message on a task instance. */
type Props = {
  task: {
    approvalMessage?: string | null;
    rejectMessage?: string | null;
    revisionMessage?: string | null;
  };
};

const OrganiserReactionMessageBlock: FC<Props> = ({task}) => {
  const {t} = useTranslate();
  const message =
    task?.approvalMessage || task?.rejectMessage || task?.revisionMessage;
  const title = task?.rejectMessage
    ? t("common.tasks.reaction.rejection_reason")
    : task?.approvalMessage
    ? t("common.tasks.reaction.approval_notes")
    : t("common.tasks.reaction.revision_notes");

  if (message) {
    return (
      <TaskSection title={title}>
        <RichText content={message} />
      </TaskSection>
    );
  }
  return null;
};

export default OrganiserReactionMessageBlock;
